import { PRONOUNS } from "~/patients/constants/constants";
import { RELATIONSHIPS } from "~/patients/constants/relationships";
import {
  UpdatePatientDetailsForm,
  UpdatePatientDetailsRequest,
} from "~/providers/types/patients";

export const updatePatientDetailsFormToRequest = (
  values: UpdatePatientDetailsForm,
): UpdatePatientDetailsRequest => {
  const pronounsGroup =
    values.pronouns.pronouns === PRONOUNS.other
      ? values.pronouns.customPronouns!.split("/")
      : values.pronouns.pronouns.split("/");

  const hasCustomRelationship =
    values.emergencyContactRelationship === RELATIONSHIPS.OTHER;

  return {
    patient_id: values.patientId,
    name: values.name,
    last_name: values.lastName,
    birthday: values.dateOfBirth,
    address: {
      street: values.streetAddress,
      apartment: values.apartment,
      city: values.city,
      state: values.state,
      zipcode: values.zipCode,
    },
    emergency_contact: {
      name: values.emergencyContactFirstName,
      last_name: values.emergencyContactLastName,
      phone_number: values.emergencyContactMobileNumber,
      email: values.emergencyContactEmail,
      relationship: hasCustomRelationship
        ? values.emergencyCustomRelationship!
        : values.emergencyContactRelationship,
    },
    pronouns: {
      subject: pronounsGroup[0],
      object: pronounsGroup[1],
      possessive: pronounsGroup[2],
    },
  };
};
